<div
  class="drop-zone relative rounded-lg border border-dashed border-slate-600 bg-slate-900/40 p-5 text-center text-slate-400"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">
  @if (imageDataUrl) {
    <button class="clp-btn clp-btn-danger clp-btn-sm btn-delete" type="button" (click)="delete()">
      <i class="fa-solid fa-trash-can"></i>
    </button>
  }
  <div class="drop-message">
    <span class="text-sm">{{'fileUpload.dragDropMessage' | translate }}</span>
    <button class="clp-btn clp-btn-secondary clp-btn-sm ml-1" type="button" (click)="fileInput.click()">{{'fileUpload.selectImage' | translate }}</button>
    <input #fileInput type="file" (change)="onFileSelected($event)" accept="image/*" hidden>
  </div>
  @if (imageDataUrl) {
    <div class="preview overflow-hidden rounded-md border border-slate-700">
      <img class="w-full" [src]="imageDataUrl" alt="Preview">
    </div>
  }
</div>
